module.exports = __webpack_public_path__ + "img/pc_bx.6dbea0f2.png";